export const defaultSelectedOffer = 'standard'
